<template>
  <div class="coupon-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div class="form-group row header-custom-switch">
            <div class="col-sm-10 col-form-label uppercase">
              <strong>
                <h3>
                  <router-link :to="{ name: 'email_template_list'}" class="float-left mr-1 main-link">{{$t('notification.email_template')}}</router-link> / {{$t('coupon.detail')}}
                </h3>
              </strong>
            </div>

            <legend class="col-sm-2 col-form-label">
              <span style="margin-right: 15px;">
                {{$t('menu.active')}}
              </span>
              <c-switch style="margin-top: 0" class="active" type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="item.active" :value="1" :uncheckedValue="0" />
            </legend>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">

          <!-- Basic information -->
          <b-card header-tag="header" footer-tag="footer" class="header">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('coupon.basic_information') }}</strong>
                <label class="switch switch-sm switch-text switch-info float-right" @click="updateBasicInformationStatus" v-b-toggle.basic_information_content>
                  <i class="fa fa-sort-down" v-if="basicInformationStatus"></i>
                  <i class="fa fa-sort-up" v-if="!basicInformationStatus"></i>
                </label>
            </div>
            <b-collapse :visible.sync="basicInformationStatus" id="basic_information_content">
              <b-form class="row">
                <b-col cols="12">
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('notification.code')}}</legend>
                    <div class="col-sm-10" >
                      <b-form-select
                        v-model="item.email_type_id" v-bind:value="item.email_type_id"
                        :options="email_types" v-bind:placeholder="$t('common.email_types')"
                        :state="!$v.item.email_type_id.$invalid">
                      </b-form-select>
                      <b-form-invalid-feedback :id="'email-type-feedback'">
                        <p class="help is-danger" v-if="!$v.item.email_type_id.required">{{ $t('message.required_filed') }}</p>
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                  <!-- <div class="form-group row" v-show="$store.getters.languages.length > 1">
                    <legend class="col-sm-2 col-form-label">{{$t('notification.mixed_languages')}}</legend>
                    <div class="col-sm-10" >
                      <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true" v-model="mixed_lang" :value="1" :uncheckedValue="0" @change="updateStatusItem(mixed_lang)" />
                    </div>
                  </div> -->
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('notification.name')}}</legend>
                    <div v-for="lang in display_languages" :class="'col-sm-' + (10 /display_languages.length)" :key="lang.id" >
                      <b-form-input
                        v-model="item.name[lang]"
                        v-bind:placeholder="$t('common.text_'+lang)"
                        :state="!!multiLangName[lang]"
                        :name="`name[${lang}]`" />
                      <b-form-invalid-feedback :id="'name-feedback'" :state="!!multiLangName[lang]">
                        <p class="help is-danger" >{{ $t('message.required_filed') }}</p>
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('notification.subject')}}</legend>
                    <div v-for="lang in display_languages" :class="'col-sm-' + (10 / display_languages.length)" :key="lang.id" >
                      <b-form-input
                        v-model="item.subject[lang]"
                        v-bind:placeholder="$t('common.text_'+lang)"
                        :state="!!multiLangSubject[lang]"
                        :name="`subject[${lang}]`" />
                      <b-form-invalid-feedback :id="'subject-feedback'" :state="!!multiLangSubject[lang]">
                        <p class="help is-danger">{{ $t('message.required_filed') }}</p>
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('notification.content')}}</legend>
                    <div id="ckeditor_div" v-for="lang in display_languages" :class="'col-sm-' + (10 / display_languages.length)" :key="lang">
                      <ckeditor :update="update" v-model="item.content[lang]" :id="'content_' + lang" :language="lang" :height="'400px'" :uploadImageUrl="uploadImageUrl" :client="client" :x-token="xToken"
                      :name="`content[${lang}]`"
                      :state="!!multiLangContent[lang]"></ckeditor>
                      <b-form-invalid-feedback :id="'content-feedback'" :state="!!multiLangContent[lang]">
                        <p class="help is-danger">{{ $t('message.required_filed') }}</p>
                      </b-form-invalid-feedback>
                    </div>
                  </div>
                  <div class="form-group row">
                    <legend class="col-sm-2 col-form-label">{{$t('notification.note')}}</legend>
                    <div class="col-sm-10" >
                      <b-form-textarea
                                    class="form-control"
                                    v-model="item.note"
                                    aria-describedby="note-feedback"/>
                    </div>
                  </div>
                </b-col>
              </b-form>
            </b-collapse>
          </b-card>
          <!-- Basic information -->

          <div slot="footer" class="card-footer">
            <router-link :to="{ name: 'email_template_list', query: {rollback: 1}}" class="btn border-radius-4px bg-main float-left ml-4"><i class="fa fa-arrow-left"></i> {{$t('common.back')}}</router-link>
            <div class="btn-save">
              <b-button :disabled="!validId || !validName || !validSubject || !validContent" variant="success"
                        v-on:click="saveTemplate()">&nbsp; {{ $t('common.save')}}
              </b-button>
            </div>
          </div>

        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {required, between} from 'vuelidate/lib/validators'
  import cSwitch from '../../../components/Switch'
  import Ckeditor from '../../editors/CKEditor'
  import MaskedInput from 'vue-text-mask'
  import DatePicker from 'vue2-datepicker'

  let vm = null

  const REQUIRED_FIELD = ['name', 'subject', 'content']
  const HTML_FIELD = ['content']

  export default {
    props: {
      id: {
        type: [String, Number],
        required: true,
        default: 'create'
      }
    },
    components: {
      cSwitch,
      Ckeditor
    },
    data: function () {
      return {
        authUser: this.$auth.user().user_info.user,
        update: false,
        prefix_crm_url: this.$store.getters.config.main.base_site_url,
        itemLimit: 10000,
        isProcessing: false,
        email_types: [],
        display_languages: [],
        item: {
          id: '',
          name: {},
          active: 1,
          subject: {},
          content: {},
          note: '',
          email_type_id: ''
        },
        basicInformationStatus: true,
        languages: Object.keys(this.$i18n.messages),
        validId: false,
        validName: false,
        validSubject: false,
        validContent: false,
        multiLangName: {},
        multiLangSubject: {},
        multiLangContent: {},
        mixed_lang: this.$store.getters.languages.length == 1 ? 0 : 1,
        client: localStorage.getItem('clientID'),
        uploadImageUrl: ''
      }
    },
    mixins: [
      validationMixin
    ],
    computed: {
      rules () {
        return {
          name: {
            required
          },
          email_type_id: {
            required
          },
          subject: {
            required
          },
          content: {
            required
          }
        }
      }
    },
    validations () {
      return {
        item: this.rules
      }
    },
    methods: {
      updateBasicInformationStatus () {
        this.basicInformationStatus = !this.basicInformationStatus
      },
      getEmailTypeList () {
        vm.axios.notification.getEmailTypeList({},
          function(response){
            vm.email_types = response.data.data.items.map((item) => {
              return {text: item.code, value: item.id}
            })
          })
      },
      saveTemplate () {
        vm.$dialog
          .confirm(vm.$t('email_template.update_email_template_confirmation'), {
            html: true,
            okText:(vm.id == 'create' || vm.id == undefined) ? vm.$t('common.create') : vm.$t('common.update'),
            cancelText: vm.$t('common.cancel')
          })
          .then(function () {
            vm.$bus.$emit('loading', 'block')
            vm.isProcessing = true
            const savedTemplate = vm._.cloneDeep(vm.item)
            for (const lang in savedTemplate.content) {
              savedTemplate.content[lang] = btoa(unescape(encodeURIComponent(savedTemplate.content[lang])))
            }
            if (vm.id == 'create' || vm.id == undefined) {
              delete savedTemplate.id
              vm.axios.notification.createEmailTemplate(savedTemplate, function (response) {
                vm.$toastr.success(vm.$t('message.save_successful'), vm.$t('message.success'), {})
                vm.isProcessing = false
                vm.$router.push({name: 'email_template_list'})
              }, function () {
                vm.isProcessing = false
              }, { email: vm.authUser.email })
            } else {
              vm.axios.notification.updateEmailTemplate(savedTemplate, function (response) {
                vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
                vm.isProcessing = false
              }, function () {
                vm.isProcessing = false
              }, { email: vm.authUser.email })
            }
            vm.$bus.$emit('loading', 'none')
          })
      },
      getTemplateAttributeDetail () {
        vm.isProcessing = true
        if (!vm.id) return
        // Get template attribute detail
        vm.axios.notification.getEmailTemplateDetail(vm.id, function (response) {
          vm.item = vm._.cloneDeep(response.data.data.item)
          vm.update = true
          if (Object.keys(vm.item.content).length == 1) {
            vm.display_languages = ['en']
            vm.mixed_lang = 0
          } else {
            vm.mixed_lang = 1
          }
        }, function (error) {
        })
      },
      updateStatusItem (isMultiLanguage) {
        if (!isMultiLanguage) {
          vm.display_languages = ['en']
        } else {
          vm.display_languages = vm._.cloneDeep(vm.$store.getters.languages)
          vm.update = true
        }
        if (vm.id != 'create' && vm.id !== undefined &&
          !vm.isProcessing) {
          vm.item.id = vm.id
          vm.getTemplateAttributeDetail()
        }
        vm.validateRequireField()
        vm.$forceUpdate()
      },
      validateField (fieldName) {
        let langs = vm.display_languages
        let result = true
        let data = vm.item[fieldName]
        for (let l of langs) {
          vm[`multiLang${fieldName[0].toUpperCase()}${fieldName.slice(1)}`][l] = vm.validateData(data[l], HTML_FIELD.includes(fieldName))
          result = result && vm[`multiLang${fieldName[0].toUpperCase()}${fieldName.slice(1)}`][l]
        }

        return result
      },
      validateData (data, isHtml) {
        let result = false

        if (data !== undefined && data != '') {
          let str = data.replaceAll(' ', '')
          if (isHtml) {
            str = str.replace(/<[^>]*(>|$)|&nbsp;|&zwnj;|&raquo;|&laquo;|&gt;/g, '').trim()
          }
          result = true
          if(0 == str.length) {
            result = false
          }
        }

        return result
      },
      validateRequireField () {
        vm.validData = true
        for(let f of REQUIRED_FIELD) {
         vm[`valid${f[0].toUpperCase()}${f.slice(1)}`] = vm.validateField(f)
        }
      }
    },
    created: function () {
      vm = this
      vm.uploadImageUrl = process.env.host + '/' + process.env.version + '/' + process.env.prefix_tenant + '/content/upload-image'
      vm.xToken = this.$auth.user().token
      this.getEmailTypeList()
    },
    watch: {
      'item.name': {
        handler (name) {
          vm.validName = vm.validateField('name')
        },
        deep: true
      },
      'item.email_type_id': {
        handler (emailTypeId) {
          vm.item.email_type_id = emailTypeId
          vm.validId = true
        },
        deep: true
      },
      'item.subject': {
        handler (subject) {
          vm.validSubject = vm.validateField('subject')
        },
        deep: true
      },
      'item.content': {
        handler (content) {
          vm.validContent = vm.validateField('content')
        },
        deep: true
      }
    },
    updated: function () {
      if (vm.id != 'create' && vm.id !== undefined &&
        !vm.isProcessing) {
        vm.item.id = vm.id
        vm.getTemplateAttributeDetail()
      }
    },
    mounted: function () {
      if (vm.id != 'create' && vm.id !== undefined &&
        !vm.isProcessing) {
        vm.item.id = vm.id
        vm.getTemplateAttributeDetail()
      }
      vm.display_languages = vm._.cloneDeep(vm.$store.getters.languages)
    }
  }
</script>

<style>
  .coupon-form input,
  .coupon-form textarea,
  .coupon-form select,
  .coupon-form .multiselect__tags {
      border-radius: 4px !important;
  }

  .multiselect__tags{
      border-radius: 0 !important;
  }

  .is-invalid .multiselect__tags {
      border-color: #f86c6b;
  }

  .coupon-form .switch-success > .switch-input:checked ~ .switch-label,
  .coupon-form .btn-success,
  .coupon-form .draw-map,
  .coupon-form .btn-primary
  {
    background: #0086FF !important;
    border-color: #0086FF !important;
    border-radius: 3px;
  }

  .coupon-form .btn-secondary{
    border-radius: 3px;
  }

  /*checkbox style*/
  .coupon-form  .form-check:after,
  .coupon-form .form-check:before {
      content: " ";
      display: table;
      content: "";
      line-height: 0;
  }

  .coupon-form .form-check input[type="checkbox"] {
      opacity: 0;
      z-index: 1;
      cursor: pointer;
  }

  .coupon-form .form-check label {
      min-height: 20px;
      padding-left: 15px;
      cursor: pointer;
      display: inline-block;
      max-width: 100%;
      margin-bottom: 5px;
      font-weight: normal;
      vertical-align: middle;
      position: relative;
  }

  .coupon-form .form-check label::before {
      border-radius: 50%;
      content: "";
      display: inline-block;
      position: absolute;
      width: 20px;
      height: 20px;
      left: 0;
      margin-left: -10px;
      border: 1px solid #cccccc;
      background-color: #fff;
      -webkit-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
      -o-transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
      transition: border 0.15s ease-in-out, color 0.15s ease-in-out;
  }

  .coupon-form .form-check input[type="checkbox"]:checked + label::before {
      background-color: #0086FF;
      border-color: #0086FF;
  }

  .coupon-form .form-check .form-check-input:disabled ~ label {
    cursor: not-allowed;
  }

  .coupon-form .form-check input[type="checkbox"]:checked + label::after {
      font-family: 'FontAwesome';
      content: "\f00c";
      color: #fff;
  }

  .coupon-form .form-check label::after {
      display: inline-block;
      position: absolute;
      width: 16px;
      height: 16px;
      left: 0;
      top: 0;
      margin-left: -10px;
      padding-left: 4px;
      padding-top: 1px;
      font-size: 12px;
      color: #0086FF;
  }
  /*checkbox style*/
  .coupon-form #customize-field .col-sm-10
  {
    padding-left: 8px;
  }

  .coupon-form .form-check-inline{
    margin-right: 1rem;
  }

  .coupon-form .modal-lg{
    max-width: 95%;
    margin-top: 0;
  }

  .coupon-form .modal-body{
    padding: 0 1rem;
  }

  .coupon-form .padding-none{
    padding: 0;
  }

  .applicable-store label span{
    width: 48px;
  }

  .applicable-store select{
    margin-right: 20px;
  }
  .not_apply_date .mx-input-append {
    display: none!important;
  }

  .not_apply_date .mx-calendar-header {
    width: 100%!important;
  }
  .not_apply_date .mx-calendar-content {
    width : 100%!important;
    height: 100%!important;
  }
  .not_apply_date .mx-time-list{
    height: 225px;
  }

</style>

<style scoped>
  #application_result_content .gray-background{
    border-radius: 0;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  #application_result_content .gray-light-background{
    border-radius: 0;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }

  /*input file */
  .file-select > .select-button {
    padding: 7px;
    color: white;
    border-radius: .2rem;
    text-align: center;
    font-weight: bold;
    background: #0086FF !important;
    border-color: #0086FF !important;
    cursor: pointer;
    margin-top: 3px;
  }

  .file-select > input[type="file"] {
    display: none;
  }
  /*input file*/

  .applicable-store input{
    margin-top: 5px;
  }

  .switch-custom{
    max-width: 5.3%;
  }

  .table-bordered{
    margin-top: 10px;
  }

  .table-bordered thead{
    background-color: #E1E6EB;
  }

  .table-bordered tbody{
    background-color: #F4F6F8;
  }

  .table-bordered th{
    border: none;
  }

  .table-bordered .center{
    text-align: center;
  }

  .col-sm-2-custom{
    flex: 0 0 12.66667%;
    margin-top: 2px;
    text-align: center;
  }

  .col-sm-2-custom-display-inline{
    flex: 0 0 12.66667%;
    margin-top: 2px;
    text-align: center;
    display: inline-flex;
  }

  .coupon-form .btn-save{
    float: right;
    margin-right: 22px;
  }

  .coupon-form .switch.switch-icon{
    margin-top: 5px;
  }

  .coupon-form .header-custom{
    margin-top: 15px;
  }

  .coupon-form .header-custom-switch{
    margin-top: 5px;
    margin-bottom: 0;
  }

  .coupon-form .header-custom-switch .uppercase{
    display: inline-flex;
  }

  .coupon-form .header-custom-switch .col-form-label{
    text-align: right;
  }

  .coupon-form .header-custom-switch .active{
    float: right;
  }

  .coupon-form div.header,
  .coupon-form .header .card-header{
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
  }

  .coupon-form .card-footer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }

  .coupon-form .add-more{
    padding-left: 0;
  }

  .coupon-form .add-more{
    color: #0086FF;
    cursor: pointer;
  }

  .coupon-form .add-more .fa{
    margin-right: 10px;
    font-size: 15px;
    border-radius: 50%;
    border: 1px solid #0086FF;
    width: 18px;
    height: 17px;
    color: #0086FF;
    padding-left: 2px;
  }

  .gray-background .form-control{
    /*padding: 8px;*/
    border: 1px solid gray;
  }

  .gray-background{
    background: #E1E6EB;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #DDE2E8;
  }

  .gray-light-background{
    background: #F4F6F8;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #DDE2E8;
  }

  .gray-background .row{
    margin-bottom: 0px;
  }

  .remark .btn-danger{
    margin-top: 7px;
    background-color: #fff;
  }

  .gray-light-background .btn-danger,
  .table-bordered .btn-danger{
    background-color: #F4F6F8;
  }

  .table-bordered .btn-danger{
    margin-top: 4px;
  }

  .gray-background .btn-danger{
    background-color: #E1E6EB;
  }

  .gray-background .btn-danger .fa,
  .gray-light-background .btn-danger .fa,
  .remark .btn-danger .fa,
  .table-bordered .btn-danger .fa{
    color: #0086FF;
    font-size: 20px;
  }

  .gray-background .col-sm-10,
  .gray-light-background .col-sm-10,
  .gray-light-background .col-sm-5{
    padding-left: 5px;
  }

  .margin-top20{
    margin-top: 20px;
  }

  .margin-bottom10{
    margin-bottom: 10px;
  }

  .clear-both{
    margin-bottom: 15px;
  }

  .card{
    margin-bottom: 0;
  }

  .coupon-image{
    margin: 0;
    padding: 0;
    display: inline-flex;
  }

  .coupon-image img{
    width: 100%;
  }

  .coupon-properties legend{
    width: auto;
    resize: both;
  }

  .coupon-properties .check-is-member{
    max-width: 16%;
  }

  .preview-image {
    width: 100%;
  }

  .font-size-inherit {
    font-size: inherit;
  }

</style>



// WEBPACK FOOTER //
// src/views/admin/email-template/BaseForm.vue